import api from '../base';
import { PricingEshopProductMargins } from './pricingMarginsTypes';
import { mockPricingEshopProductMargins } from './pricingMarginsMocks';

const PRICING_ESHOP_PRODUCT_MARGINS_PATH = '/management/pricing/eshop-products/margins';

export async function getPricingEshopProductMargins(
  marketplaceCode: string,
  partnerProductCode: string,
  signal?: AbortSignal,
): Promise<PricingEshopProductMargins> {
  const response = await api.get<PricingEshopProductMargins>(
    PRICING_ESHOP_PRODUCT_MARGINS_PATH,
    {
      params: { marketplaceCode, partnerProductCode },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onGet(PRICING_ESHOP_PRODUCT_MARGINS_PATH)
  .reply(200, mockPricingEshopProductMargins);

export async function updatePricingEshopProductMargins(
  request: PricingEshopProductMargins,
  signal?: AbortSignal,
): Promise<void> {
  await api.put<void>(PRICING_ESHOP_PRODUCT_MARGINS_PATH, request, { signal });
}

api.mock
  .onPut(PRICING_ESHOP_PRODUCT_MARGINS_PATH)
  .reply(200);
